"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.StyledButtonIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("../theme/stitches.config");

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _clsx = _interopRequireDefault(require("../utils/clsx"));

var _jsxRuntime = require("react/jsx-runtime");

const defaultProps = {
  className: ''
};
const StyledButtonIcon = (0, _stitches.styled)('span', {
  dflex: 'center',
  position: 'absolute',
  left: '$$buttonPadding',
  right: 'auto',
  top: '50%',
  transform: 'translateY(-50%)',
  color: 'inherit',
  zIndex: '$1',
  '& svg': {
    background: 'transparent'
  },
  variants: {
    isRight: {
      true: {
        right: '$$buttonPadding',
        left: 'auto'
      }
    },
    isSingle: {
      true: {
        position: 'static',
        transform: 'none'
      }
    }
  }
});
exports.StyledButtonIcon = StyledButtonIcon;

const ButtonIcon = ({
  children,
  className,
  ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButtonIcon, {
    className: (0, _clsx.default)('nextui-button-icon', className),
    ...props,
    children: children
  });
};

ButtonIcon.toString = () => '.nextui-button-icon';

const MemoButtonIcon = /*#__PURE__*/_react.default.memo(ButtonIcon);

var _default = (0, _withDefaults.default)(MemoButtonIcon, defaultProps);

exports.default = _default;